module.exports = __webpack_public_path__ + "static/media/story_11.eb46bd04.jpg";